// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"a5cc3c8c","145":"11f158af","181":"7a2924f8","204":"c4163deb","300":"998e2cdd","328":"29cc49d6","412":"4889fc65","467":"e99e4276","549":"93c126ff","760":"859df884","785":"29e924b3","869":"3de68c7a","915":"eb2f094a","970":"dee7379e"}[chunkId] + ".chunk.js";
};